import { Link } from 'react-router-dom';
import { LegalPageLayout } from '../../components/legal/LegalPageLayout';
import { DJ_MINIMUM_AGE, LEGAL_CONTACT_EMAIL, LEGAL_GOVERNING_STATE, LEGAL_OPERATOR_NAME } from '../../config/legal';

export function TermsPage() {
  const contactLink = <a href={`mailto:${LEGAL_CONTACT_EMAIL}`}>{LEGAL_CONTACT_EMAIL}</a>;

  return (
    <LegalPageLayout title="Terms of Service" otherPage={{ to: '/privacy', label: 'Privacy Policy' }}>
      <section>
        <h2>1. Agreeing to these terms</h2>
        <p>
          VoteBeats is operated by {LEGAL_OPERATOR_NAME} (&quot;VoteBeats&quot;, &quot;we&quot;, &quot;us&quot;). By
          creating a DJ account, using an event page, or installing VoteBeats Bridge, you agree to these Terms and to
          our <Link to="/privacy">Privacy Policy</Link>. If you don&apos;t agree, please don&apos;t use VoteBeats.
        </p>
      </section>

      <section>
        <h2>2. Accounts</h2>
        <ul>
          <li>DJ accounts are invite-only during the beta.</li>
          <li>You must be at least {DJ_MINIMUM_AGE} years old to create a DJ account.</li>
          <li>Keep your password safe. You are responsible for what happens under your account.</li>
          <li>Each account is for one person. Don&apos;t share it or create accounts for others.</li>
        </ul>
      </section>

      <section>
        <h2>3. Beta service</h2>
        <p>
          VoteBeats is in beta. It is free during the beta and is provided &quot;as is&quot;. Features may change, be
          added or be removed at any time. We may approve or decline event size upgrades, and we may pause accounts.
        </p>
      </section>

      <section>
        <h2>4. DJ responsibilities</h2>
        <p>As a DJ, you are responsible for:</p>
        <ul>
          <li>the events you run and the content you show at them</li>
          <li>
            <strong>music licensing and public performance rights for the music you play.</strong> VoteBeats does not
            provide or license music.
          </li>
          <li>the contact information you put on your event pages</li>
          <li>following the laws and rules that apply at your venue</li>
        </ul>
      </section>

      <section>
        <h2>5. Attendee conduct</h2>
        <p>
          Don&apos;t use nicknames, messages or dedications to harass anyone, or to post hateful, explicit or otherwise
          inappropriate content. DJs can reject or remove any request or content at their event.
        </p>
      </section>

      <section>
        <h2>6. Your content</h2>
        <p>
          You keep ownership of what you add to VoteBeats, such as event details, messages and requests. You give
          VoteBeats permission to store, show and process that content to run the service and to keep service history,
          as described in section 8 of the <Link to="/privacy">Privacy Policy</Link>.
        </p>
      </section>

      <section>
        <h2>7. Acceptable use</h2>
        <p>
          Don&apos;t abuse, scrape, reverse engineer or interfere with VoteBeats or the people using it, and don&apos;t
          use VoteBeats for anything that breaks the law.
        </p>
      </section>

      <section>
        <h2>8. VoteBeats Bridge</h2>
        <p>
          We give you a personal, non-transferable license to install and use VoteBeats Bridge with your VoteBeats
          account. Bridge updates itself automatically.
        </p>
      </section>

      <section>
        <h2>9. Third-party services</h2>
        <p>
          VoteBeats works with music players and catalogs such as Apple Music, Spotify and TIDAL. Those services have
          their own terms, and you are responsible for following them.
        </p>
      </section>

      <section>
        <h2>10. Ending or pausing an account</h2>
        <p>
          You can delete your DJ account at any time in Settings. We can pause or close accounts that break these
          Terms or put the service or its users at risk.
        </p>
      </section>

      {/* Needs legal review before inviting DJs the owner doesn't know */}
      <section>
        <h2>11. Disclaimers and limitation of liability</h2>
        <p>
          VoteBeats is provided &quot;as is&quot; and &quot;as available&quot;, without warranties of any kind, whether
          express or implied, including warranties of merchantability, fitness for a particular purpose and
          non-infringement. We don&apos;t promise that VoteBeats will be uninterrupted, error-free or available at any
          particular event.
        </p>
        <p>
          To the fullest extent the law allows, {LEGAL_OPERATOR_NAME} is not liable for any indirect, incidental,
          special, consequential or punitive damages, or for lost profits, data or goodwill, arising from your use of
          VoteBeats. Our total liability for any claim relating to the service is limited to the greater of the
          amount you paid VoteBeats in the 12 months before the claim, or US $50.
        </p>
      </section>

      <section>
        <h2>12. Changes, governing law and contact</h2>
        <p>
          We may update these Terms. When we do, we change the date at the top of this page, and DJs are asked to
          accept the new version the next time they use VoteBeats.
        </p>
        <p>These Terms are governed by the laws of the State of {LEGAL_GOVERNING_STATE}, USA.</p>
        <p>Questions? Contact us at {contactLink}.</p>
      </section>
    </LegalPageLayout>
  );
}
